<template>
  <div class="unwhite-code-home" />
</template>

<script>
export default {
  // actCode = ceshi01  actid = 73
  name: 'unwhite-code-home',
  created() {

  }
}
</script>

<style lang="scss" scoped>
  @import "../../common/css/modules/global";

  .unwhite-code-home {
    @include scroll;
    background: white;
  }
</style>
